import { render, staticRenderFns } from "./BillingsSettingsTemplate.vue?vue&type=template&id=d8e824e8"
import script from "./BillingsSettingsTemplate.vue?vue&type=script&lang=js"
export * from "./BillingsSettingsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports